import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IconsService {
  constructor(private http: HttpClient) {}

  public static svgsetIconUrl(icon: string): string {
    return `#${icon}`;
  }

  public init() {
    this.http
      .get(`/assets/icons/svgset.svg`, {
        responseType: 'text',
        withCredentials: false,
        observe: 'response',
      })
      .subscribe({
        next: (response) => {
          if (response.body) {
            const div = document.createElement('div');
            div.setAttribute('style', 'display: none;');
            div.innerHTML = response.body;
            document.getElementsByTagName('body')[0].appendChild(div);
          }
        },
      });
  }
}
